import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Formulas from "../components/Formulas";
import WhyCml from "../components/WhyCml";
import HowItWorks from "../components/HowItWorks";
import BeforeAfter from "../components/BeforeAfter";
import Story from "../components/Story";
import Contact from "../components/Contact";

export default function Landing() {
    return (
        <main>
            <Hero />
            <Marquee />
            <Formulas />
            <WhyCml />
            <HowItWorks />
            <BeforeAfter />
            <Story />
            <Contact />
        </main>
    );
}
